import { useMutation } from "@tanstack/vue-query"
import { axios } from "@/axios"

/**
 * Applies a host's purchased package to their existing freemium event instead of creating a new
 * event. Called when the host accepts the upgrade prompt shown on entering their onboarding link.
 */
export async function upgradeFreemiumEvent(token: string, eventVaultId: number) {
  const response = await axios.post(`api/event/payment/${token}/upgrade`, { EventVaultID: eventVaultId })

  return response.data?.Data as number
}

const UPGRADE_FREEMIUM_EVENT_KEY = "upgradeFreemiumEvent"

export function useUpgradeFreemiumEvent() {
  return useMutation({
    mutationKey: [UPGRADE_FREEMIUM_EVENT_KEY],
    mutationFn: ({ token, eventVaultId }: { token: string, eventVaultId: number }) => upgradeFreemiumEvent(token, eventVaultId),
  })
}
